import React, { useContext, useState, useEffect } from "react";
import { Route as RouterRoute, Redirect } from "react-router-dom";
import moment from "moment";

import { AuthContext } from "../context/Auth/AuthContext";
import BackdropLoading from "../components/BackdropLoading";
import { openApi } from "../services/api";

const Route = ({ component: Component, isPrivate = false, ...rest }) => {
	const { isAuth, loading, user } = useContext(AuthContext);
	const [landingPageEnabled, setLandingPageEnabled] = useState(() => {
		const cached = localStorage.getItem("landingPageEnabled");
		return cached === null ? true : cached === "true";
	});

	// Check landing page status on mount
	useEffect(() => {
		const checkLandingPage = async () => {
			try {
				const { data } = await openApi.get("/landing-page-enabled");
				localStorage.setItem("landingPageEnabled", data.enabled);
				setLandingPageEnabled(data.enabled);
			} catch {
				setLandingPageEnabled(true);
			}
		};
		checkLandingPage();
	}, []);

	// Verificar se a empresa está vencida
	const isCompanyExpired = () => {
		if (!user || !user.company || user.company.id === 1) {
			return false; // Empresa ID 1 nunca expira
		}

		const dueDate = user.company.dueDate;
		if (!dueDate) return false;

		// Comparar apenas as datas (sem horas) para permitir acesso até 23h59 do dia do vencimento
		const hojeInicio = moment().startOf('day');
		const vencimentoInicio = moment(dueDate).startOf('day');

		// Empresa está vencida apenas após o dia do vencimento
		return hojeInicio.isAfter(vencimentoInicio, 'day');
	};

	if (!isAuth && isPrivate) {
		// Redirect to login if landing page is disabled, otherwise to /home
		const redirectPath = landingPageEnabled ? "/home" : "/login";
		return (
			<>
				{loading && <BackdropLoading />}
				<Redirect to={{ pathname: redirectPath, state: { from: rest.location } }} />
			</>
		);
	}

	// Redireciona usuários autenticados que tentam acessar login/signup para o dashboard
	// Mas permite que usuários autenticados acessem a landing page (/home)
	if (isAuth && !isPrivate && rest.path !== "/home") {
		return (
			<>
				{loading && <BackdropLoading />}
				<Redirect to={{ pathname: "/", state: { from: rest.location } }} />
			</>
		);
	}

	// Se está autenticado e a empresa está vencida
	if (isAuth && isPrivate && isCompanyExpired()) {
		// Permite acesso apenas ao /financeiro-aberto
		if (rest.path !== "/financeiro-aberto") {
			return (
				<>
					{loading && <BackdropLoading />}
					<Redirect to={{ pathname: "/financeiro-aberto", state: { from: rest.location } }} />
				</>
			);
		}
	}

	return (
		<>
			{loading && <BackdropLoading />}
			<RouterRoute {...rest} component={Component} />
		</>
	);
};

export default Route;
